import {
    CategoryDetailsComponent as SourceCategoryDetailsComponent,
} from 'SourceComponent/CategoryDetails/CategoryDetails.component';

import './CategoryDetails.override.style';
import React from 'react';
import Html from '@scandipwa/scandipwa/src/component/Html';
import TextPlaceholder from '@scandipwa/scandipwa/src/component/TextPlaceholder';
import Image from '@scandipwa/scandipwa/src/component/Image';
import { ImageRatio } from '@scandipwa/scandipwa/src/component/Image/Image.type';

export class CategoryDetailsComponent extends SourceCategoryDetailsComponent {
    renderCategoryDescription() {
        const {
            category: { description, id },
            isCurrentCategoryLoaded,
        } = this.props;
        const { isPrefetchValueUsed, actionName: { description: preloadDescription } } = window;

        // if (isPrefetchValueUsed) {
        //     if (preloadDescription) {
        //         return <Html content={preloadDescription} />;
        //     }

        //     return null;
        // }

        // if ((!id || !isCurrentCategoryLoaded)) {
        //     return this.renderCategoryDescriptionPlaceholder();
        // }

        if (!description) {
            return null;
        }

        let data = description.replaceAll('&lt;', '<');
        let data2 = data.replaceAll('&gt;', '>');

        return <div className='CategoryDetails-CategoryDescription-Content'>
            <Html content={data2} />
        </div>;
    }

    renderCategoryImage() {
        const {
            category: { image, id },
            isCurrentCategoryLoaded,
        } = this.props;

        // if (!id || !isCurrentCategoryLoaded) {
        //     return this.renderCategoryImagePlaceholder();
        // }

        if (!image) {
            return null;
        }

        return (
            // <Image
            //     mix={{ block: 'CategoryDetails', elem: 'Picture' }}
            //     src={image || ''}
            //     ratio={ImageRatio.IMG_CUSTOM}
            // />
            <div className='CategoryDetails-Picture'>
                <img src={image || ''} />
            </div>
        );
    }

    renderCategoryName() {
        const {
            category: { name, id, most_popular_banner },
        } = this.props;
        const {
            actionName: {
                name: preloadName,
            },
            isPrefetchValueUsed,
        } = window;
        const categoryName = isPrefetchValueUsed ? preloadName : name;

        if (!id && !name && !isPrefetchValueUsed) {
            return null;
        }

        return (
            <h1 className="CategoryDetails-Heading">
                {name}
            </h1>
        );
    }

    renderMostPopularBanner() {
        const { category: { most_popular_banner } } = this.props;

        if (!most_popular_banner) {
            return null;
        }

        const data = most_popular_banner.replaceAll('&lt;', '<');
        const data2 = data.replaceAll('&gt;', '>');

        return <div className='CategoryDetails-MostPopularBanner'>
            <Html content={data2} />
        </div>;
    }

    render() {
        const { category: { most_popular_banner } } = this.props;

        if (most_popular_banner) {
            return this.renderMostPopularBanner();
        }

        return (
            <article className="CategoryDetails">
                <div className="CategoryDetails-Description">
                    {this.renderCategoryName()}
                    {this.renderCategoryDescription()}
                </div>
                {this.renderCategoryImage()}
            </article>
        );
    }
}

export default CategoryDetailsComponent;
